const root = () => document.querySelector('[data-testid="spore-app"]');
window.__sporeFx = [];

// Restartable CSS effect class on the app root.
export const fx = (cls, ms) => {
  try {
    const el = root();
    if (!el) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    clearTimeout(el[`_fx_${cls}`]);
    el[`_fx_${cls}`] = setTimeout(() => el.classList.remove(cls), ms);
    window.__sporeFx.push(cls);
  } catch (e) {
    /* visual fx are optional */
  }
};

export const impact = (level = 1) => {
  fx(level >= 2 ? "fx-shake-big" : "fx-shake", level >= 2 ? 900 : 650);
  fx("fx-flash", 800);
};

export const glitchHit = (hard = false) => fx(hard ? "fx-glitch-hard" : "fx-glitch", hard ? 420 : 200);
export const thump = () => fx("fx-thump", 260);
